export const NONE_SENTINEL = '_NONE_';